import React, { Fragment, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import { getInt } from 'utils/functions';
import DocumentTypePropertyContainer from './DocumentTypePropertyContainer';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_DOCUMENT_TYPES } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const [title, setTitle] = useState('');
  const match = useRouteMatch();

  const documentTypeId = useMemo(() => getInt(match.params.documentTypeId), [match.params.documentTypeId]);
  const propertyId = useMemo(() => getInt(match.params.propertyId), [match.params.propertyId]);

  const onClickClose = useCallback(() => {
    historyContext.push(`/documentTypes/${documentTypeId}/documentTypeProperties`);
  }, [documentTypeId, historyContext]);

  const onChangeDocumentTypePropertyTitle = title => {
    setTitle(title);
  };

  const onRedirect = useCallback(
    propId => {
      historyContext.push(`/documentTypes/${documentTypeId}/documentTypeProperties/${propId}`);
    },
    [documentTypeId, historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_DOCUMENT_TYPES}>
        <DocumentTypePropertyContainer
          documentTypeId={documentTypeId}
          propertyId={propertyId}
          onRedirect={onRedirect}
          onChangeDocumentTypePropertyTitle={onChangeDocumentTypePropertyTitle}
        />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
